import LoadPreviousButton from "./LoadPreviousButton";
import PropTypes from "prop-types";
import { withTranslation } from "../translation";
import { useDispatch, useSelector } from "react-redux";
import {
  loadPrevious,
  selectSearchIsPagingBackward
} from "../../state/modules/search";
import { getPreviousPagePath } from "../../state/modules/search/domains/pagination/selectors/getPreviousPagePath";

const ConnectedLoadPreviousButton = ({ formatTranslation, formatLink }) => {
  const dispatch = useDispatch();

  return (
    <LoadPreviousButton
      isLoadingPrevious={useSelector(selectSearchIsPagingBackward)}
      loadPrevious={args => dispatch(loadPrevious(args))}
      previousPagePath={useSelector(getPreviousPagePath)}
      formatTranslation={formatTranslation}
      formatLink={formatLink}
    />
  );
};

ConnectedLoadPreviousButton.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  formatLink: PropTypes.func.isRequired
};

export default withTranslation(ConnectedLoadPreviousButton);
